// Plan-based feature gating
// plan_status values: 'free' | 'trial' | 'active' | 'enterprise'
//   - 'free': new default after signup (free tier)
//   - 'trial': legacy default; treated as free
//   - 'active': paid Professional plan (after admin approves payment)
//   - 'enterprise': organizations

export const FREE_SKILL_LIMIT = 3;

export function isProfessional(user) {
  if (!user) return false;
  return user.plan_status === 'active' || user.plan_status === 'enterprise';
}

export function getPlanLabel(user) {
  if (!user) return 'Free';
  if (user.plan_status === 'active') return 'Professional';
  if (user.plan_status === 'enterprise') return 'Enterprise';
  return 'Free';
}

// Feature flags
export const features = {
  canDownloadPdf: isProfessional,
  canSendMessages: isProfessional,
  canSendReferenceInvites: isProfessional,
  canAddUnlimitedSkills: isProfessional,
  canUsePortfolio: isProfessional,
};
